<template>
<v-card>


    <v-layout column class="pa-2">
        <div class="detail font-weight-bold pa-1 ma-0">Roles</div>
        <!-- SEARCH -->
        <v-layout row no-gutters align="center" class="im-search ma-3">
            <v-col cols="12">
                <v-layout row fill-height>
                    <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                    <v-btn class="mx-1" color="primary" outlined @click="openRoleDialog" style="height: 30px">Add Role</v-btn>
                </v-layout>
            </v-col>
        </v-layout>
        <!-- ./ SEARCH -->
        <!--data table-->
        <v-card tile flat class="mx-1">
            <v-row no-gutters align="center" class="secondary regular">
                <v-col cols="4" class="pa-2">Services</v-col>
                <v-col cols="8" class="pa-2">Roles</v-col>
            </v-row>
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>
        <!-- DATATABLE ROWS -->
        <v-card tile flat class="mx-1" style="background-color: transparent !important;">
            <v-layout column>
                <v-data-iterator :items="user_roles" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">

                    <template v-slot:default="props">
                        <template v-for="item in props.items">
                            <v-row no-gutters align="center" class="secondary my-1 pa-2 regular">
                                <v-col cols="4" class="px-2">
                                    <div>{{ item.service_name }}</div>
                                </v-col>
                                <v-col cols="8">
                                    <v-chip v-for="(role, index) in item.roles" :key="index" :style="{background: item.service_color}" close @click:close="deleteConfimationRole(role.role_id)">
                                        {{role.role_name}}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </template>
                    </template>

                    <template v-slot:no-data>
                        <v-alert :value="true" type="info" color="primary">
                            No data available.
                        </v-alert>
                    </template>

                </v-data-iterator>
            </v-layout>
        </v-card>

    </v-layout>
    <!-- delete role confirmation dialog -->
    <v-dialog v-model="delete_role_dialog" max-width="320px" persistent>
        <v-card>
            <v-card-text class="pt-3">
                Are you sure you want to delete this role from user?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="delete_role_dialog=false">Cancel</v-btn>
                <v-btn color="red" dark :loading="loading_delete" @click="destroyRole">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- end delete role confirmation dialog -->
    <!-- add new role dialog -->
    <v-dialog v-model="role_dialog" max-width="640px">
        <v-card flat tile color="primary">
            <v-card-title class="important white--text" height="50">Add Role</v-card-title>
            <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-0': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
                <v-card-text>
                    <im-search-services class="mb-3" @input="selectService($event)" ref="services" />
                    <v-divider class="mb-2" />
                    <v-text-field label="Name" v-model="service.name" readonly hide-details />
                    <v-text-field label="Slug" v-model="service.slug" readonly hide-details />
                    <v-autocomplete :items="roles" v-model="role" label="Roles" item-text="name" return-object />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="exitDialogRoles()">Cancel</v-btn>
                    <v-btn color="primary" @click="addRole()" :disabled="!role">Add Role</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
    <!-- add new role dialog -->
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import SearchServices from "../../utils/SearchServices.vue";
import pinterest from "@/assets/pinterest.svg"

export default {
    props: {
        item_id: {
            type: [Number, String]
        },
        dialog: Boolean
    },
    components: {
        "im-search-services": SearchServices
    },
    data() {
        return {
            loading_save: false,
            loading_delete: false,

            // dialogs modals
            delete_role_dialog: false,
            role_dialog: false,
            role_d_id: null,
            //props
            service: {},
            valid: true,
            menu: false,

            // role table and search
            role: null,
            loading: false,
            roles: [],
            search: null,
            search_timeout: 500,
            user_roles: [],
            data_loading: false,
            total: 0,
            page: 1,
            size: 5,
            itemsPerPageOptions: [5, 10, 25],

        };
    },

    computed: {},

    watch: {
        dialog: {
            handler() {
                this.user_roles = [];
                this.total = 0;
                this.page = 1;
                this.size = 5;
            }
        },
        item_id: {
            handler() {
                this.getUserRoles();
            }
        },

        page: {
            handler() {
                this.getUserRoles();
            }
        },

        size: {
            handler() {
                this.getUserRoles();
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getUserRoles, 500);
            }
        }
    },

    created() {
        this.getUserRoles()
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format("DD MMM YY");
        },

        getUserRoles() {
            if(!this.item_id) {
                return;
            }
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            let params = {
                params: {
                    search: search,
                    size: this.size,
                    page: this.page
                }
            };
            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles/users/" + this.item_id + "/roles";

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.user_roles = response.data.data;
                    this.total = response.data.pagination.total;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getRoles() {
            // refresh roles
            this.roles = [];

            // construct params object
            let params = {
                params: {
                    //search: this.role,
                    service_ids: [this.service.id]
                }
            };

            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles/roles";

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.roles = response.data.data;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        selectService(service) {
            if(service) {
                this.service = this.$clone(service);
            } else {
                this.service = {};
            }
            this.getRoles();
        },
        // role funtions
        openRoleDialog() {
            this.role_dialog = true;
        },

        exitDialogRoles() {
            this.role_dialog = false;
            this.service = {};
            this.roles = [];
            this.role = null;
            this.$refs.services.clear();
        },

        addRole() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles";

            this.$axios.post(endpoint + "/users/" + this.item_id + "/roles/" + this.role.id) // eslint-disable-next-line
                .then(response => {
                    this.getUserRoles();
                    this.success('Role added!');
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.role_dialog = false;
                });
        },

        deleteConfimationRole(item) {
            this.role_d_id = null;
            this.delete_role_dialog = true;
            this.role_d_id = item;
        },

        destroyRole() {
            this.delete_role_dialog = false;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles/users/" + this.item_id + "/roles";

            // call delete endpoint
            this.$axios.delete(endpoint + "/" + this.role_d_id) // eslint-disable-next-line
                .then(response => {
                    this.success('Role deleted!');
                    this.getUserRoles();
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.delete_dialog = false;
                });
        },

    }
};
</script>

<style>
.pointer {
    cursor: pointer;
}
</style>
